import axios from 'axios';

const adminUrl = process.env.VUE_APP_ADMIN_URL;

export default class AlliancesService {
  static async getAll(page, limit, search, activeFilter = null) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      let url = `${adminUrl}/alliances?page=${page}&limit=${limit}`;
      if (search != null && search.length !== 0) {
        url += `&name=${encodeURIComponent(search)}`;
      }
      if (activeFilter !== null) {
        url += `&active=${activeFilter}`;
      }
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      if (response.data.status === 'ok') {
        return { status: 'ok', data: response.data.data };
      }
      return { status: 'error' };
    } catch {
      return { status: 'error' };
    }
  }

  static async getById(allianceId) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.get(`${adminUrl}/alliances/${allianceId}`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      if (response.data.status === 'ok') {
        return { status: 'ok', data: response.data.data };
      }
      return { status: 'error' };
    } catch {
      return { status: 'error' };
    }
  }

  static async create(payload) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.post(`${adminUrl}/alliances`, payload, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      if (response.data.status === 'ok') {
        return { status: 'ok', data: response.data.data };
      }
      return { status: 'error', message: response.data.message };
    } catch (error) {
      return {
        status: 'error',
        message: error?.response?.data?.message || 'Error inesperado'
      };
    }
  }

  static async update(allianceId, payload) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.put(`${adminUrl}/alliances/${allianceId}`, payload, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      if (response.data.status === 'ok') {
        return { status: 'ok', data: response.data.data };
      }
      return { status: 'error', message: response.data.message };
    } catch (error) {
      return {
        status: 'error',
        message: error?.response?.data?.message || 'Error inesperado'
      };
    }
  }

  static async createBenefit(allianceId, payload) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.post(`${adminUrl}/alliances/${allianceId}/benefits`, payload, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      if (response.data.status === 'ok') {
        return { status: 'ok', data: response.data.data };
      }
      return { status: 'error', message: response.data.message };
    } catch (error) {
      return {
        status: 'error',
        message: error?.response?.data?.message || 'Error inesperado'
      };
    }
  }

  static async updateBenefit(allianceId, benefitId, payload) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.put(
        `${adminUrl}/alliances/${allianceId}/benefits/${benefitId}`,
        payload,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      if (response.data.status === 'ok') {
        return { status: 'ok', data: response.data.data };
      }
      return { status: 'error', message: response.data.message };
    } catch (error) {
      return {
        status: 'error',
        message: error?.response?.data?.message || 'Error inesperado'
      };
    }
  }
}
